import axios from 'axios'
import { Message } from 'element-ui';
import router from '../../../router/index'
import util from '../util/util'
import config from '../config'

// 创建一个 axios 实例
const service = axios.create({
    withCredentials: true,
    baseURL: config.baseUrl + '/api/',
    timeout: 50000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {

        config.method = config.isGet ? 'GET' : 'POST'

        let authToken = util.cacheGet('AuthToken')
        if(authToken) {
            config.headers['Authorization'] = 'Bearer ' + authToken;
        }
        return config
    },
    error => {
        // 发送失败
        // console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        return {
            status: 0,
            msg: '请求发生错误'
        }
        // return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/assets/js/api/index.js